module.exports = __webpack_public_path__ + "static/img/industry-2.aada2fa0.jpg";